export default __webpack_public_path__ + "static/media/login-owl.db55ed94.svg";